const ONE_DAY_MS = 1000 * 3600 * 24;

export function daysAgo(timestamp) {
    const date = new Date(timestamp);
    const diff = Date.now() - date.getTime();
    return Math.ceil(diff / ONE_DAY_MS);
}
